import { z } from 'zod';
import { EsmeBindMode } from '../../../models/esmeModel';
import { LogLevel } from '../../../types/logLevel';

const positiveIntNumber = z.number().int().positive();

export const esmeUserValidationSchema = z.object({
  username: z.string().max(15),
  password: z.string().min(4).max(8),
  bindModes: z.array(z.nativeEnum(EsmeBindMode)).nonempty(),
  userAllowIps: z.array(z.string()).nullish(),
  defaultSmscIds: z.array(z.string()).nullish(),
  maxBinds: positiveIntNumber,
  maxReceiverBinds: positiveIntNumber.nullish(),
  maxTransmitterBinds: positiveIntNumber.nullish(),
  maxTransceiverBinds: positiveIntNumber.nullish(),
  sessionTimeout: positiveIntNumber,
  logFile: z.string(),
  logLevel: z.nativeEnum(LogLevel),
  throughput: positiveIntNumber,
  throughputIn: positiveIntNumber.nullish(),
  throughputOut: positiveIntNumber.nullish(),
});

export const esmeMtRouteValidationSchema = z.object({
  smscIds: z.array(z.string()).nonempty(),
  receiverPrefixes: z.array(positiveIntNumber).nonempty(),
});

export const esmeMoRoutesValidationSchema = z.object({
  smscId: z.string(),
  receiverRegexes: z.array(z.string()).nonempty(),
});

export const esmeFormValidationSchema = z.object({
  user: esmeUserValidationSchema,
  mtRoutes: z.array(esmeMtRouteValidationSchema).optional(),
  moRoutes: z.array(esmeMoRoutesValidationSchema).optional(),
});
